import dayjs from "dayjs";

export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const DATE_TIME_FORMAT_REG_EXP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;

export const DATE_FORMAT = "YYYY-MM-DD";

export const DATE_FORMAT_REG_EXP = /^\d{4}-\d{2}-\d{2}$/;

export function parseDateTime(value) {
  if (!value) return null;
  if (dayjs.isDayjs(value)) return value;
  // value is expected to be a string "YYYY-MM-DD HH:mm:ss"
  const d = dayjs(value, DATE_TIME_FORMAT, true);
  return d.isValid() ? d : null;
}

export function formatDateTime(value) {
  if (!value) return "";
  const d = dayjs.isDayjs(value) ? value : dayjs(value);
  return d.isValid() ? d.format(DATE_TIME_FORMAT) : "";
}

export function parseDate(value) {
  if (!value) return null;
  if (dayjs.isDayjs(value)) return value;
  // value is expected to be a string "YYYY-MM-DD"
  const d = dayjs(value, DATE_FORMAT, true);
  return d.isValid() ? d : null;
}

export function formatDate(value) {
  if (!value) return "";
  const d = dayjs.isDayjs(value) ? value : dayjs(value);
  return d.isValid() ? d.format(DATE_FORMAT) : "";
}
